export type TSortable = 'fullName' | 'createdAt' | 'username';

export const sortedFields = {
  fullName: 'fullName',
  username: 'username',
  createdAt: 'createdAt',
};
